import ThreeRenderSpace from "../render-spaces/three-render-space"


class CameraHandler {
    protected renderSpace : ThreeRenderSpace 
    onRegister(renderSpace : ThreeRenderSpace) {
        this.renderSpace = renderSpace

        
    }
}

export default CameraHandler